module.exports = __webpack_public_path__ + "static/HSRP-af7a0ffded0af26a038f6da342d0d415.png";